import React from 'react';
import { PieTooltipProps } from '@nivo/pie';
import { formatDecimal } from '@app/common';
import { darken } from 'polished';
import { PieChartDataMobxDto } from '../../../../../../models/mobx/dtos/statistic/pie-chart-data-mobx-dto';

function getContrastColor(bgColor: string) {
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 130 ? 'black' : '#ffffff';
}

interface IBasePieChartTooltipProps {
    data: React.PropsWithChildren<PieTooltipProps<PieChartDataMobxDto>>;
    currency?: string | null;
    type?: string | null;
}

export const Tooltip: React.FC<IBasePieChartTooltipProps> = ({ currency, data }) => {
    const backgroundColor = darken(0.2, data.datum.color);

    return (
        <div
            className="relative flex flex-col rounded-medium p-small shadow-large"
            style={{ background: backgroundColor, color: getContrastColor(backgroundColor) }}
        >
            {data.datum.data.id !== data.datum.data.name && (
                <>
                    <div className="mb-[1.5rem] max-w-[20rem] break-words text-[1.6rem] leading-[2.2rem] font-bold">
                        {data.datum.data.name}{' '}
                        <span className="text-[1.2rem] font-normal opacity-70">({data.datum.data.id})</span>
                    </div>
                    <div className="flex items-baseline gap-[0.5rem]">
                        <div className="text-[2rem] font-bold">{data.datum.formattedValue}</div>
                        {data.datum.data.absoluteValue !== 0 && (
                            <div className="text-[1.6rem] font-normal">
                                ({formatDecimal(data.datum.data.absoluteValue, 1)}&nbsp;{currency})
                            </div>
                        )}
                    </div>
                </>
            )}

            {data.datum.data.id === data.datum.data.name && (
                <div className="flex items-baseline gap-[0.5rem]">
                    <div className="text-[1.6rem] font-bold">{data.datum.data.id}</div>
                    <div className="text-[1.6rem] font-normal">({data.datum.formattedValue})</div>
                </div>
            )}
            <span
                className="pointer-events-none absolute left-1/2 h-0 w-0 -translate-x-1/2 border-[1rem] border-transparent"
                style={{ top: '100%', borderTopColor: backgroundColor }}
                aria-hidden
            />
        </div>
    );
};
